
/*

参数设置

 */
// 提示框的时长
const toastTime = 3000;
// 卡密充值的RSA公钥
const publicKey = ``;
// 平台的验签秘钥 : 车传奇秘钥
const platformKey = "";
// 产品id : 车传奇
const productId = "";
//已转让卡券URL
const transfer_link = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxebd89d3e609ecb34&redirect_uri=https%3a%2f%2fwww.hq178.cn%2fm%2f%23%2fmy%2forders&response_type=code&scope=snsapi_base&state=0#wechat_redirect";
/*

全局设置

*/
// 设置页面背景色
const setBodyBackground = (type, color = 'var(--bgColor)') => {
    // type: 1 设置， 2 还原
    if (type === 1) {
        document.querySelector('html').setAttribute('style', `background-color:${color};`);
    } else if (type === 2) {
        document.querySelector('html').removeAttribute('style');
    }
}
// 动态设置px
const setPx = (val) => {
    if (val && typeof val === 'number') {
        let pageFontSize = document.querySelector('html').style.fontSize;
        pageFontSize = pageFontSize.slice(0, -2)
        pageFontSize = pageFontSize / 100
        return Number((val * pageFontSize).toFixed(6))
    } else {
        console.log('请传入number类型的数据')
    }
}
/* 

参数校验

 */

//分割字符  随意|
const splitStr = '|';
//校验手机号
const regPhone = (val) => {
    let reg = /^(1[3-9][0-9])\d{8}$/;
    if (reg.test(val)) {
        return true;
    }
    return false;
}
//校验中文
const regSymbol = (val) => {
    let reg = /^[\u4e00-\u9fa5]+$/;
    if (reg.test(val)) {
        return true;
    }
    return false;
}
//车牌验证
const regCarNo = (val) => {
    return /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(val);
}
// 移除表情包
const removeEmoji = content => {
    return (content) && content.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, "");
};
// 格式化金钱 后端返回的值为分，返回值为字符串
// type 0 保留两位小数 1 保留整数或两位小数
const formatMoney = (val, type) => {
    if (typeof val === 'number') {
        let changeVal = val,
            integer = Math.trunc(changeVal),
            decimal = Number((changeVal - integer).toFixed(2));
        if (type === 1) {
            // 小数部分大于0则返回带两位数的值，否者直接返回整数部分；
            if (decimal > 0) {
                return changeVal.toFixed(2);
            } else {
                return integer;
            }
        } else {
            return changeVal.toFixed(2);
        }
    } else if (typeof val === 'string') {
        console.log('请传入数字类型的值')
    } else {
        return '0'
    }
}
//格式金额 转换
const toBranch = (val) => {
    return val * 100;
}
// 获取服务静态图片
// 传type时获取type的图片，不传的话获取全部
const getServiceStatic = (type) => {
    const files = require.context(
        '../../public/static/images/',
        true,
        /.jpg|.png$/
    );
    let staticArr = [];
    files.keys().map(item => {
        item = item.replace("./", "");
        if (type) {
            if (item.includes(type)) {
                item = require("../../public/static/images/" + item);
                let arry = { img_url: "", imglink: "" };
                arry.img_url = item;
                staticArr.push(arry);
                return item;
            }
        } else {
            let arry = { img_url: "", imglink: "" };
            arry.img_url = item;
            staticArr.push(arry);
            return item;
        }

    });
    return staticArr;
}
/*

路由跳转

*/
import router from '../router';
const push = (data) => {
    router.push({ ...data }).catch(() => { });
}
const replace = (data) => {
    router.replace({ ...data }).catch(() => { });
}
const go = (data) => {
    router.go(data);
};
const back = (data) => {
    router.go(data);
};

/*
 
信息提示、弹窗提示、加载提示、成功提示跳转 
 
*/
import { Toast, Dialog, Notify } from 'vant';
// 加载中的提示
const loading = (msg = '加载中...', time) => {
    return Toast.loading({
        duration: time || 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        message: msg
    });
}
// 成功提示
const success = (params) => {
    if (typeof params === 'string' && !params) {
        return false;
    }
    Toast.success(params);
}
// 成功提示同步 isDuration: 1 直接跳转 
const successSync = (params, cb) => {
    if (typeof params === 'string' && !params) {
        return false;
    }
    Toast.success({
        // overlay: true,
        forbidClick: true,
        message: params,
        onClose: cb
    });
    // if (isDuration && isDuration === 1) {
    //     Toast.clear()
    //     cb()
    // } else {
    //     let time = setInterval(() => {
    //         clearInterval(time);
    //         cb()
    //     }, 1000);
    // }
}
// 失败提示
const error = (params) => {
    if (typeof params === 'string' && !params) {
        return false;
    }
    Toast(params);
}
// 长文字提示
const toast = (params) => {
    if (typeof params === 'string' && !params) {
        return false;
    }
    // Toast(params);
    Notify({ type: 'danger', message: params, duration: toastTime });

}
// 关闭Toast弹窗
const clear = () => {
    return Toast.clear();
}
// 输入框的确认
const confirm = (message, title, confirmButtonColor) => {
    return Dialog.confirm({
        message,
        title,
        confirmButtonColor,
    });
}
// 确认
const alert = (message, title = '',confirmButtonText ='', cb = () => { }) => {
    if (message) {
        return Dialog.alert({
            message,
            title,
            confirmButtonText:confirmButtonText==''?'确认':confirmButtonText,
			confirmButtonColor:''
        }).then(() => {
            cb()
        });
    }
}

/*

设置全局缓存

 */
const setItem = (key, value, duration = 30 * 60 * 1000) => {
    if (key && value === null) {
        return removeItem(key);
    }
    let now = new Date().getTime();
    return localStorage.setItem(key, `${JSON.stringify(value)}${splitStr}${now + duration}`)
}
const getItem = (key) => {
    let now = new Date().getTime();
    let item = localStorage.getItem(key)
    // 是否存在storage
    if (!item) {
        return null;
    }
    // 是否失效
    let index = item.lastIndexOf(splitStr);
    let value = item.substr(0, index);
    let endTime = item.substr(index + splitStr.length)
    if (now > endTime) {
        removeItem(key);
        return 0;
    }
    try {
        return JSON.parse(value)
    } catch (err) {
        return 1
    }
}
const removeItem = (key) => {
    return localStorage.removeItem(key)
}
/*
判断设备
*/
export default {
    isIOS: /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()),
    isAndroid: /android/.test(navigator.userAgent.toLowerCase())
};

function IdCardAge(identityCard) {
    var len = (identityCard + "").length;
    var strBirthday = "";
    if (len == 18) {
        //处理18位的身份证号码从号码中得到生日和性别代码
        strBirthday =
            identityCard.substr(6, 4) +
            "/" +
            identityCard.substr(10, 2) +
            "/" +
            identityCard.substr(12, 2);
    }
    if (len == 15) {
        strBirthday =
            "19" +
            identityCard.substr(6, 2) +
            "/" +
            identityCard.substr(8, 2) +
            "/" +
            identityCard.substr(10, 2);
    }
    //时间字符串里，必须是“/”
    var birthDate = new Date(strBirthday);
    var nowDateTime = new Date();
    var age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (
        nowDateTime.getMonth() < birthDate.getMonth() ||
        (nowDateTime.getMonth() == birthDate.getMonth() &&
            nowDateTime.getDate() < birthDate.getDate())
    ) {
        age--;
    }
    return age;
}
function validateIdCard(idCard) {
    //15位和18位身份证号码的正则表达式  
    var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    var obj = {};
    //如果通过该验证，说明身份证格式正确，但准确性还需计算  
    if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
            var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里  
            var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组  
            var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和  
            for (var i = 0; i < 17; i++) {
                idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
            }

            var idCardMod = idCardWiSum % 11;//计算出校验码所在数组的位置  
            var idCardLast = idCard.substring(17);//得到最后一位身份证号码  

            //如果等于2，则说明校验码是10，身份证号码最后一位应该是X  
            if (idCardMod == 2) {
                if (idCardLast == "X" || idCardLast == "x") {
                    //alert("恭喜通过验证啦！");
                    obj = { result: true, msg: "" }
                }
                else {
                    obj = { result: false, msg: "身份证号码错误" }
                }
            }
            else {
                //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码  
                if (idCardLast == idCardY[idCardMod]) {
                    //alert("恭喜通过验证啦！");
                    obj = { result: true, msg: "" }
                }
                else {
                    obj = { result: false, msg: "身份证号码错误" }
                }
            }
        }
        else {
            obj = { result: false, msg: "身份证号码错误" }
        }
    }
    else {
        obj = { result: false, msg: "身份证格式不正确" }
    }
    return obj;
}
//将两个json对象合并
function twoJsonMerge(json1, json2) {
    // var length1 = 0, length2 = 0, jsonStr, str;
    var newjson = {};
    for (var ever in json1) {
        newjson[ever] = json1[ever];
        // length1++;
    }
    for (var ever2 in json2) {
        newjson[ever2] = json2[ever2];
        // length2++;
    }
    // if (length1 && length2) str = ',';
    // else str = '';
    // jsonStr = ((JSON.stringify(json1)).replace(/,}/, '}') + (JSON.stringify(json2)).replace(/,}/, '}')).replace(/}{/, str);
    return newjson;
}

export {
    twoJsonMerge,
    toastTime,
    publicKey,
    platformKey,
    productId,
    transfer_link,
    setBodyBackground,
    setPx,
    regPhone,
    regSymbol,
    removeEmoji,
    regCarNo,
    formatMoney,
    toBranch,
    getServiceStatic,
    push,
    replace,
    go,
    back,
    loading,
    success,
    successSync,
    error,
    toast,
    clear,
    confirm,
    alert,
    setItem,
    getItem,
    removeItem,
    validateIdCard,
    IdCardAge
}


